module.exports = __webpack_public_path__ + "static/media/Branch_code_updated.1f307228.pdf";